import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IDeleteFrameworkControlDialogProps } from "./DeleteFrameworkControlDialog";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useDeleteFrameworkControlDialogHooks(props: IDeleteFrameworkControlDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeFramework = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: any) => {
                props.onDeleted();

                snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.controlName } }));
            },
        });
    };

    async function remove() {
        return await deleteHttp<{}>(`/frameworkControls/${props.controlId}`);
    }

    return {
        removeFramework,
        inProgess: removeMutation.isLoading,
    };
}
